import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getIdentityRegionaleEditiqueRequest: ['response'],
    getIdentityRegionaleEditiqueSuccess: ['response', 'loading'],
    getIdentityRegionaleEditiqueFailure: ['error'],
})

export const getIdentityRegionaleEditiqueTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getIdentityRegionaleEditiqueSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getIdentityRegionaleEditiqueFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getIdentityRegionaleEditiqueRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_IDENTITY_REGIONALE_EDITIQUE_REQUEST]: getIdentityRegionaleEditiqueRequest,
    [Types.GET_IDENTITY_REGIONALE_EDITIQUE_SUCCESS]: getIdentityRegionaleEditiqueSuccess,
    [Types.GET_IDENTITY_REGIONALE_EDITIQUE_FAILURE]: getIdentityRegionaleEditiqueFailure,
})
